import { forwardRef, InputHTMLAttributes } from 'react'
import { format } from 'date-fns'

interface DateTimePickerProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'min'> {
  label?: string
  error?: string
  minDate?: Date
}

export const DateTimePicker = forwardRef<HTMLInputElement, DateTimePickerProps>(
  ({ label, error, minDate, className = '', id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-')
    const minValue = minDate ? format(minDate, "yyyy-MM-dd'T'HH:mm") : undefined

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="label">
            {label}
          </label>
        )}
        <input
          ref={ref}
          type="datetime-local"
          id={inputId}
          min={minValue}
          className={`input ${error ? 'input-error' : ''} ${className}`}
          aria-invalid={!!error}
          aria-describedby={error ? `${inputId}-error` : undefined}
          {...props}
        />
        {error && (
          <p id={`${inputId}-error`} className="mt-1 text-sm text-error">
            {error}
          </p>
        )}
      </div>
    )
  }
)

DateTimePicker.displayName = 'DateTimePicker'
